import { createIcon } from '@chakra-ui/icon'

const EmptyMediaCollectionGraphic = createIcon({
  viewBox: '0 0 260 200',
  path: (
    <g>
      <defs>
        <style>
          {
            '.st0{fill:#DBF9ED;}.st1{fill:#5F7970;}.st2{fill:#64C99F;}.st3{fill:#F9CC7D;}.st4{fill:#2C93FB;}.st5{fill:#027DF9;}.st6{fill:#5BA8F8;}.st7{opacity:0.28;}.st8{fill:#87C5F9;}.st9{fill:#FFFFFF;}.st10{fill:#1876B5;}'
          }
        </style>
      </defs>
      <g>
        <path
          className="st0"
          d="M90,27.7c1,2.4,2.6,4.5,3.6,7c2.6,6.7,17.6,37.4,71.7,36.1c60.8-1.5,95.5,27,89,66.3   c-10,59.8-116.9,75.1-191.7,39.9S-2,43.1,27.1,20.2C51.8,0.6,81.3,7.6,90,27.7z"
        />
      </g>
      <g>
        <g>
          <g>
            <path
              className="st1"
              d="M191.6,159.3c-1.1,1.3-2.1,2.6-3.1,4.1c-0.5,0.7-0.9,1.5-1.4,2.3c-0.1,0.2-0.2,0.4-0.3,0.6l-0.3,0.7     c-0.1,0.3-0.2,0.5-0.2,0.8c-0.1,0.3-0.1,0.6-0.1,1l2.4-0.2c0-0.7,0.2-1.5,0.4-2.3c0.2-0.8,0.5-1.5,0.9-2.3c0.7-1.5,1.4-3,2.2-4.4     L191.6,159.3z"
            />
          </g>
          <g>
            <path
              className="st2"
              d="M190,161.6c0,0,2.8-3.4,15.9-6.3c13.1-2.9,34.7-13.1,31.1-23.2c-3.6-10.1-28.2-4-37.8,8.1     C189.5,152.4,190,161.6,190,161.6z"
            />
          </g>
          <g>
            <path
              className="st1"
              d="M191,160.4l0.6,0.3c12.2-20.5,34.1-23.7,34.3-23.8l-0.1-0.7C225.6,136.3,203.3,139.6,191,160.4z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              className="st1"
              d="M189.6,169.7c-0.9,0.2-1.7,0.5-2.6,0.9c-0.4,0.2-0.9,0.4-1.3,0.7c-0.2,0.1-0.5,0.3-0.7,0.5     c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.3,0.3-0.4,0.5l2.3,0.9c0.1-0.3,0.4-0.6,0.7-0.9c0.3-0.3,0.6-0.6,0.9-0.8     c0.6-0.5,1.3-1,2-1.5L189.6,169.7z"
            />
          </g>
          <g>
            <path
              className="st3"
              d="M188.4,170.5c0,0,2-0.9,8.6,0.6c6.6,1.5,18.6,1.5,19.2-3.8c0.5-5.4-12-7.9-19-4.5     C190.2,166.3,188.4,170.5,188.4,170.5z"
            />
          </g>
          <g>
            <path
              className="st1"
              d="M189.1,170.1l0.4,0.5c9.9-6.7,20.5-3.4,20.6-3.4l0.2-0.6C210.2,166.6,199.2,163.2,189.1,170.1z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                className="st4"
                d="M182.8,59.7h-76.6l-12.8-8.3H58.2c-6,0-10.9,5-10.7,11l1.2,40.9h144.8V70.4      C193.5,64.5,188.7,59.7,182.8,59.7z"
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                className="st4"
                points="62.6,135.1 187.4,135.1 187.4,68.5 62.6,68.4     "
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                className="st4"
                points="58,139.7 182.2,139.7 182.2,73.1 58,73     "
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  className="st5"
                  d="M192.2,85.1H50.9c-4.4,0-7.8,3.8-7.3,8l10.1,77.4c0.5,3.6,3.6,6.2,7.3,6.2h120.6c3.7,0,6.8-2.6,7.3-6.2       l10.6-77.4C200,88.9,196.6,85.1,192.2,85.1z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  className="st6"
                  d="M191.9,87.2H50.7c-4.4,0-7.8,3.8-7.3,8l10.1,77.4c0.5,3.6,3.6,6.2,7.3,6.2h120.6c3.7,0,6.8-2.6,7.3-6.2       l0.7-5.1l9.9-72.3C199.8,91,196.4,87.2,191.9,87.2z"
                />
              </g>
            </g>
          </g>
          <g className="st7">
            <g>
              <path
                className="st8"
                d="M191.9,87.2h-91.8l91.5,63.1l7.6-55.1C199.8,91,196.4,87.2,191.9,87.2z"
              />
            </g>
          </g>
          <g className="st7">
            <g>
              <path
                className="st8"
                d="M51.6,87.2l114.1,91.6h15.6c3.7,0,6.8-2.6,7.3-6.2l0.7-5.1l-116-80.3H51.6z"
              />
            </g>
          </g>
        </g>
      </g>
      <g>
        <g>
          <circle className="st9" cx="120.5" cy="133.9" r="28.3" />
        </g>
        <g>
          <rect
            x="105.8"
            y="130.6"
            className="st6"
            width="29.9"
            height="17.3"
          />
          <g>
            <rect
              x="105.1"
              y="122.1"
              transform="matrix(0.9905 -0.1372 0.1372 0.9905 -16.0393 17.7052)"
              className="st6"
              width="30.6"
              height="6.4"
            />
            <polygon
              className="st9"
              points="124.2,123.2 127,125.7 130.4,125.2 127.6,122.7    "
            />
            <polygon
              className="st9"
              points="117.3,124.1 120.1,126.6 123.6,126.2 120.7,123.6    "
            />
            <polygon
              className="st9"
              points="110.4,125.1 113.2,127.6 116.7,127.1 113.9,124.6    "
            />
            <polygon
              className="st9"
              points="131.1,122.2 133.9,124.7 133.5,121.9    "
            />
            <polygon
              className="st9"
              points="106.9,125.6 107.3,128.4 109.7,128.1 106.9,125.6    "
            />
          </g>
          <circle className="st10" cx="120.8" cy="139.3" r="2" />
        </g>
      </g>
    </g>
  ),
})

export default EmptyMediaCollectionGraphic
